import { useSuspenseQuery } from '@tanstack/react-query';
import { ConfigService } from 'app/config/config.service';
import { userSchema } from 'app/agriculture/hooks/users/userSchema';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { ApiEndpoint } from 'app/agriculture/queries/apiEndpoints';
import { User } from './types';
import { useCurrentUser } from 'app/agriculture/hooks/users/useCurrentUser';

export function useCurrentUserDetails() {
    const { id } = useCurrentUser();
    const { data } = useSuspenseQuery({
        queryKey: [ApiEndpoint.users, { id }],
        queryFn: async function () {
            const instance = createAxiosInstance({ baseURL: ConfigService.apiUrlRoot });
            const { data } = await instance.get<unknown>(`${ApiEndpoint.users}${id}`);
            return userSchema.parse(data) as User;
        },
    });
    //HACK: we want to get rid of this once enough of our users have logged in at least once in order to auto populate the name field, this is temporary so our demo doesn't look bad
    return {
        ...data,
        name: data.name === 'Unknown' ? data.email.split('@')[0] : data.name,
    };
}
